/* TCB runtime para a marcação do Multi 4.0.3 espelhada (BEAREFOOT-83).
   Código próprio: o JS do tema Multi é licenciado e não é copiado. Mesmos elementos/atributos/estados da marcação
   (classes de estado '!active', '!loading', '!open'; atributos opening/closing; data-element). */
(() => {
  'use strict';
  const ST = '!';
  const MQ_DESKTOP = window.matchMedia('(min-width: 992px)');
  const EV = {
    VARIANT_UPDATE: 'variant:update', VARIANT_CHANGE: 'variant:change', VARIANT_LOADING: 'variant:loading', VARIANT_UNAVAILABLE: 'variant:unavailable',
    CART_ADD: 'cart:add', CART_CHANGE: 'cart:change', CART_UPDATE: 'cart:update', CART_REGISTER: 'cart:register', CART_ERROR: 'cart:error',
    CART_REPLACE: 'cart:replace', GALLERY_SLIDE: 'product-gallery:slide-change', FORM_SUBMIT: 'product-form:submit', TOAST: 'toast-notification:open'
  };
  const state = (el, name, on = true) => el && el.classList.toggle(ST + name, !!on);
  const show = (el, on = true) => el && (on ? el.removeAttribute('hidden') : el.setAttribute('hidden', ''));
  const parse = (t) => new DOMParser().parseFromString(t, 'text/html');
  const replaceContent = (from, to, force) => {
    const src = to && (to.content || to);
    if (!from || !src) return;
    if (force || !from.isEqualNode(src)) from.replaceChildren(...src.cloneNode(true).childNodes);
  };
  // só animações finitas (spinner/letreiro infinitos dentro da gaveta prendiam o abrir/fechar) e no máximo 1,5 s
  const animationsDone = (el) => Promise.race([
    Promise.allSettled((el && el.getAnimations ? el.getAnimations({ subtree: true }) : [])
      .filter(a => { const t = a.effect && a.effect.getComputedTiming ? a.effect.getComputedTiming() : {}; return t.endTime !== Infinity && t.iterations !== Infinity; })
      .map(a => a.finished)),
    new Promise(r => setTimeout(r, 1500))]);
  const money = (cents) => {
    const fmt = (window.tcb && window.tcb.moneyFormat) || '${{amount}}';
    const v = (cents / 100).toFixed(2), [a, b] = v.split('.');
    const th = a.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => k === 'amount_no_decimals' ? th : k === 'amount_with_comma_separator' ? th.replace(/,/g, '.') + ',' + b : th + '.' + b);
  };
  window.Shopify = window.Shopify || {};
  if (!window.Shopify.formatMoney) window.Shopify.formatMoney = money;

  /* ---------- pub/sub por seção (como o Multi: assinantes da mesma section-id, ou globais) ---------- */
  const subs = new Map();
  let sigN = 0;
  const bus = {
    sub(ev, cb, o) { if (!subs.has(ev)) subs.set(ev, new Set()); const s = { cb, sec: o.sec, global: o.global, once: o.once, sig: o.sig }; subs.get(ev).add(s); return s; },
    unsub(ev, s) { subs.get(ev) && subs.get(ev).delete(s); },
    pub(ev, data, sec, sig) {
      (subs.get(ev) || []).forEach(s => {
        if ((s.sec === sec || s.global) && s.sig !== sig) { s.cb(data); if (s.once) bus.unsub(ev, s); }
      });
    }
  };

  class Base extends HTMLElement {
    constructor() { super(); this.sec = this.getAttribute('section-id'); this._sig = this.tagName + (sigN++); this._subs = []; }
    connectedCallback() { if (this._done) return; this._done = true; try { this.init && this.init(); } catch (e) { console.error(this.tagName, e); } }
    disconnectedCallback() { this._subs.forEach(([ev, s]) => bus.unsub(ev, s)); this._subs = []; this._done = false; this.destroy && this.destroy(); }
    sub(ev, cb, o = {}) { this._subs.push([ev, bus.sub(ev, cb.bind(this), { sec: this.sec, sig: this._sig, ...o })]); }
    pub(ev, data) { bus.pub(ev, data, this.sec, this._sig); }
    el(name) { return this.querySelector(`[data-element="${name}"]`); }
    els(name) { return Array.from(this.querySelectorAll(`[data-element="${name}"]`)); }
    num(a) { return Number(this.getAttribute(a)); }
    has(a) { return this.hasAttribute(a); }
  }
  const def = (n, c) => { if (!customElements.get(n)) customElements.define(n, c); };

  /* ---------- camada superior (diálogos) ---------- */
  const stack = [];
  def('modal-container', class extends Base {
    init() {
      this.dialog = this.el('dialog'); this.content = this.el('content'); this.spinner = this.el('spinner');
      this.dialog && this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      this.dialog && this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
      this.addEventListener('modal-open', (e) => { if (e.target === this) this._open(); });
      this.addEventListener('modal-close', (e) => { e.stopPropagation && 0; this._close(); });
    }
    open() { this.dispatchEvent(new CustomEvent('modal-open', { bubbles: true })); }
    close() { this.dispatchEvent(new CustomEvent('modal-close', { bubbles: true })); }
    async _remote() {
      const url = this.getAttribute('remote-url'), target = this.getAttribute('remote-target');
      if (!url || !target) return;
      if (!this.$remote) {
        state(this.spinner, 'active', true);
        try { const d = parse(await (await fetch(url)).text()); this.$remote = d.querySelector(target); } catch (e) { console.error(e); }
        state(this.spinner, 'active', false);
      }
      if (this.$remote && !this.content.contains(this.$remote)) { this.content.append(document.importNode(this.$remote, true)); this.$remote = this.content.lastElementChild; }
    }
    async _open() {
      if (!this.dialog || this.dialog.open) return;
      stack.push(this.dialog);
      this.dialog.showModal();
      document.documentElement.classList.add('tcb-modal-open');
      await this._remote();
      this.setAttribute('opening', ''); await animationsDone(this.content); this.removeAttribute('opening');
      this.dialog.dispatchEvent(new CustomEvent('modal-open', { bubbles: true }));
    }
    async _close() {
      if (!this.dialog || !this.dialog.open) return;
      stack.pop();
      this.setAttribute('closing', ''); await animationsDone(this.content);
      this.dialog.close(); this.removeAttribute('closing');
      if (!stack.length) document.documentElement.classList.remove('tcb-modal-open');
      if (this.$remote && this.has('remote-detach')) this.$remote.remove();
    }
  });
  def('modal-open', class extends Base {
    init() {
      const go = () => {
        const t = document.getElementById(this.getAttribute('target'));
        if (!t) { const fb = this.getAttribute('fallback'); if (fb) location.href = fb; return; }
        t.dispatchEvent(new CustomEvent('modal-open', { bubbles: true }));
      };
      this.addEventListener('click', go);
      this.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target === this) { e.preventDefault(); e.stopPropagation(); go(); } });
    }
  });
  def('modal-close', class extends Base { init() { this.addEventListener('click', () => this.dispatchEvent(new CustomEvent('modal-close', { bubbles: true }))); } });

  /* ---------- letreiro ---------- */
  def('moving-content', class extends Base {
    init() {
      const c = this.el('content'); if (!c) return;
      const w = c.offsetWidth;
      if (!w) { this.remove(); return; }
      const n = Math.ceil(window.innerWidth / w) + 1;
      this.replaceChildren(...Array.from({ length: n }, () => c.cloneNode(true)));
      this.style.setProperty('--content-width', `${w}`);
    }
  });

  /* ---------- carrosséis (BlazeSlider, MIT) ---------- */
  const onBlaze = (cb) => { if (window.BlazeSlider) cb(); else document.addEventListener('tcb-blaze-loaded', cb, { once: true }); };
  def('slideshow-inline-blaze', class extends Base {
    init() { if (!this.has('inert')) onBlaze(() => this._blaze()); }
    destroy() { this.slider && this.slider.destroy && this.slider.destroy(); }
    _blaze() {
      const b = this.el('blaze'); if (!b || this.slider) return;
      const per = this.num('slides-per-view'), perM = this.num('slides-per-view-mobile');
      this.slider = new window.BlazeSlider(b, {
        all: { slideGap: this.getAttribute('gap'), loop: false, slidesToShow: per, slidesToScroll: this.has('slide-by-row') ? per : 1, draggable: this.has('swipe-on-desktop') },
        '(max-width: 992px)': { slidesToShow: perM, slidesToScroll: 1, draggable: true }
      });
      if (this.has('track-active')) {
        const slides = Array.from(this.slider.slides);
        const mark = (s, e) => slides.forEach((el, i) => el.classList.toggle('blaze-active', i >= s && i <= e));
        const [s0, e0] = this.slider.states[0].page; mark(s0, e0);
        this.slider.onSlide((_, s, e) => mark(s, e));
      }
      const nav = this.els('nav'), off = this.slider.totalSlides > per;
      nav.forEach(n => show(n, off));
    }
  });
  def('slideshow-blaze', class extends Base {
    init() { onBlaze(() => this._blaze()); }
    destroy() { this.slider && this.slider.destroy && this.slider.destroy(); }
    _blaze() {
      const b = this.el('blaze'); if (!b || this.slider) return;
      const o = { slideGap: '0px', loop: this.has('loop'), slidesToShow: 1, draggable: this.has('swipe-on-desktop') };
      if (this.num('autoplay-speed')) Object.assign(o, { enableAutoplay: true, autoplayInterval: this.num('autoplay-speed') });
      this.slider = new window.BlazeSlider(b, { all: o, '(max-width: 992px)': { draggable: true } });
      if (this.has('ignore-resize')) this.slider.refresh = () => {};
      if (this.num('initial-index')) this.slideTo(this.num('initial-index'));
      const upd = () => { const c = this.slider.slides.item(0); if (c !== this._act) { this._act && this._act.classList.remove('blaze-active'); this._act = c; c.classList.add('blaze-active'); } };
      upd(); this.slider.onSlide(upd);
      this.els('nav').forEach(n => show(n, this.slider.totalSlides > 1));
      this.dispatchEvent(new CustomEvent('tcb-slider-ready'));
    }
    slideTo(i) { if (!this.slider) return; const t = this.slider.stateIndex - i; this.slider[t > 0 ? 'prev' : 'next'](Math.abs(t)); }
  });
  def('product-gallery-slider', class extends Base {
    init() {
      this.sub(EV.GALLERY_SLIDE, (i) => this._go(i));
      const hook = () => { const s = this.querySelector('slideshow-blaze'); if (s && s.slider) s.slider.onSlide((i) => this.pub(EV.GALLERY_SLIDE, i)); else setTimeout(hook, 50); };
      onBlaze(hook);
    }
    _go(i) { const s = this.querySelector('slideshow-blaze'); s && s.slideTo(i); }
  });
  def('product-gallery-thumbnails', class extends Base {
    init() {
      this.sub(EV.GALLERY_SLIDE, (i) => { const t = this.inputs().find(x => x.value === String(i)); if (t) { t.checked = true; this._scroll(t); } });
      this.addEventListener('change', (e) => { this.pub(EV.GALLERY_SLIDE, +e.target.value); this._scroll(e.target); });
    }
    inputs() { return Array.from(this.querySelectorAll('[data-element="input"]')); }
    _scroll(t) {
      if (!this.has('auto-scroll')) return;
      const lab = t.labels && t.labels[0]; if (!lab) return;
      const h = this.offsetHeight, ph = this.parentNode.offsetHeight;
      if (ph > window.innerHeight || ph >= h) { this.style.setProperty('--offset-scroll-y', '0px'); return; }
      const off = Math.max(Math.min(-lab.offsetTop + ph / 2, 0), ph - h - 4);
      this.style.setProperty('--offset-scroll-y', `${off}px`);
    }
  });

  /* ---------- dropdowns ---------- */
  def('drop-down', class extends Base {
    init() {
      this.details = this.el('details'); this.select = this.el('select');
      this._outer = (e) => { if (!this.contains(e.target)) this.close(); };
      this.addEventListener('change', (e) => {
        const t = e.target;
        if (t.hasAttribute('data-dropdown-option')) {
          e.stopPropagation();
          if (this.select) { this.select.value = t.value; this.select.dispatchEvent(new Event('change', { bubbles: true })); }
          if (this.has('close-on-change')) this.close();
        }
      });
      this.select && this.select.addEventListener('change', (e) => {
        const sv = this.el('selected-value');
        if (this.has('update-value') && sv) sv.innerText = e.target.options[e.target.selectedIndex].text;
      });
      this.details && this.details.addEventListener('toggle', () => {
        if (this.details.open) setTimeout(() => document.addEventListener('click', this._outer), 20);
        else document.removeEventListener('click', this._outer);
      });
      this.classList.remove('initial-hidden');
      const sv = this.el('selected-value'), so = this.select && this.select.querySelector('option[selected], option[data-tcb-selected="1"]');
      if (this.has('update-value') && sv && so) sv.innerText = so.text;   // rótulo inicial = opção marcada pelo servidor
    }
    close() { if (this.details) this.details.open = false; }
    destroy() { document.removeEventListener('click', this._outer); }
  });
  def('product-options-dropdown', class extends Base {
    init() {
      this.addEventListener('change', (e) => {
        const c = this.el('current'); if (c && e.target.matches('input')) c.textContent = e.target.value;
        const d = this.querySelector('drop-down'); d && d.close && d.close();
      });
    }
  });
  def('localization-dropdown', class extends Base {
    init() {
      const f = this.querySelector('form');
      f && f.addEventListener('change', () => { show(this.el('spinner'), true); f.submit(); });
    }
  });

  /* ---------- variantes (mesmo mecanismo do Multi: seção renderizada no servidor por option_values) ---------- */
  const cache = new Map();
  def('product-variant-provider', class extends Base {
    init() {
      this.cur = {
        variantId: this.getAttribute('initial-variant-id'),
        ov: (this.getAttribute('initial-options-state') || '').split(','),
        img: this.getAttribute('initial-image-position')
      };
      this.sub(EV.VARIANT_CHANGE, (d) => this._change(d));
      const k = this.key();
      if (!cache.has(k)) cache.set(k, this._map(Array.from(this.querySelectorAll('product-variant-listener'))));
    }
    key() { return `${this.sec}-${this.cur.variantId}-${this.cur.ov.join(',')}`; }
    _map(list) { const m = {}; list.forEach(l => { if (l.id) m[l.id] = l.cloneNode(true); }); return m; }
    _product() { if (!this._pj) { const s = this.querySelector('script.tcb-product-json'); this._pj = s ? JSON.parse(s.textContent) : null; } return this._pj; }
    async _change({ optionValueId, optionIndex, variantId, imagePosition }) {
      this.cur.ov[+optionIndex] = optionValueId;
      this.cur.variantId = variantId || undefined; this.cur.img = imagePosition;
      if (!this.cur.variantId) this._smart(+optionIndex);
      this.pub(EV.VARIANT_UNAVAILABLE, !this.cur.variantId);
      const k = this.key();
      if (!cache.has(k)) {
        const meta = this.el('product-meta'); state(meta, 'loading', true); this.pub(EV.VARIANT_LOADING, true);
        try {
          const p = new URLSearchParams({ section_id: this.sec, option_values: this.cur.ov.join(',') });
          const pu = this.getAttribute('product-url'); const d = parse(await (await fetch(`${pu}${pu.includes('?') ? '&' : '?'}${p}`)).text());
          const root = d.getElementById(this.id) || d;
          cache.set(k, this._map(Array.from(root.querySelectorAll('product-variant-listener'))));
        } catch (e) { console.error(e); }
        state(meta, 'loading', false); this.pub(EV.VARIANT_LOADING, false);
      }
      this.pub(EV.VARIANT_UPDATE, { imageIndex: Number(this.cur.img) - 1, imagePosition: this.cur.img, targets: cache.get(k) || {} });
      this.setAttribute('initial-variant-id', this.cur.variantId || '');
      if (this.has('product-page')) {
        const u = new URLSearchParams(); if (this.cur.variantId) u.set('variant', this.cur.variantId);
        history.replaceState({}, '', `${location.pathname}${u.toString() ? '?' + u : ''}`);
      }
    }
    _smart(changed) {
      // combinação inexistente: mantém a opção escolhida e pega a 1ª variante disponível com ela (como o seletor "smart" do Multi)
      const pj = this._product(); if (!pj) return;
      const inputs = Array.from(this.querySelectorAll('input[data-option-index]:checked'));
      const val = (inputs.find(i => +i.dataset.optionIndex === changed) || {}).value;
      const v = pj.variants.find(x => x.available && x.options[changed] === val) || pj.variants.find(x => x.options[changed] === val);
      if (!v) return;
      this.cur.variantId = String(v.id);
    }
  });
  def('product-variant-listener', class extends Base {
    init() {
      this.meta = this.closest('[data-meta-block]');
      if (this.has('emptyable')) this._hide();
      this.sub(EV.VARIANT_UPDATE, ({ targets }) => {
        const t = targets && targets[this.id]; if (!t) return;
        replaceContent(this, t, true); applyLiquidStates(this);
        if (this.has('emptyable') || this._hidden) this._hide();
        this.dispatchEvent(new CustomEvent('update', { bubbles: true }));
      });
    }
    _hide() { this._hidden = this.textContent.trim() === ''; if (this.meta) this.meta.toggleAttribute('hidden', this._hidden); }
  });
  def('product-variant-selector', class extends Base {
    init() {
      this.addEventListener('change', (e) => {
        const d = e.target.dataset; if (d.optionIndex === undefined) return;
        this.pub(EV.VARIANT_CHANGE, { optionValueId: d.optionValueId, optionIndex: d.optionIndex, variantId: d.variantId, imagePosition: d.imagePosition });
      });
      markAvailability(this);
    }
  });
  def('product-quick-view', class extends Base {
    init() {
      this.sub(EV.CART_UPDATE, () => this.dispatchEvent(new CustomEvent('modal-close', { bubbles: true })), { global: true });
      this.sub(EV.VARIANT_UPDATE, ({ imagePosition }) => {
        const sl = this.querySelector('slideshow-blaze'); if (!imagePosition || !sl) return;
        const i = this.els('media').findIndex(m => m.dataset.position === String(imagePosition));
        if (i >= 0) { sl.slideTo(i); sl.setAttribute('initial-index', i); }
      });
    }
  });
  def('product-info-loading', class extends Base { init() { this.sub(EV.VARIANT_LOADING, (s) => state(this, 'active', s)); } });
  function markAvailability(root) {
    // estados !sold-out / !unavailable das opções, a partir do JSON do produto e das opções atuais
    const prov = root.closest('product-variant-provider'); const pj = prov && prov._product ? prov._product() : null;
    if (!pj) return;
    const checked = {}; root.querySelectorAll('input[data-option-index]:checked').forEach(i => { checked[+i.dataset.optionIndex] = i.value; });
    root.querySelectorAll('input[data-option-index]').forEach(i => {
      const oi = +i.dataset.optionIndex;
      const match = pj.variants.filter(v => v.options[oi] === i.value && Object.entries(checked).every(([k, val]) => +k === oi || v.options[+k] === val));
      i.classList.toggle('!unavailable', match.length === 0);
      i.classList.toggle('!sold-out', match.length > 0 && !match.some(v => v.available));
    });
  }

  /* ---------- formulário, carrinho ---------- */
  def('product-form', class extends Base {
    init() {
      this.form = this.querySelector('[data-type=add-to-cart-form]');
      this.form && this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        const fd = new FormData(this.form);
        for (const [k, v] of [...fd.entries()]) if (typeof v === 'string' && v.trim() === '') fd.delete(k);
        if (this.has('multiple-products')) {
          const items = [...fd.entries()].filter(([k]) => k.includes('buy_with_') || k === 'id').map(([, v]) => ({ id: v, quantity: 1 }));
          bus.pub(EV.CART_ADD, { items }, this.sec);
        } else bus.pub(EV.FORM_SUBMIT, { formData: fd }, this.sec);
      });
    }
  });
  def('product-to-cart', class extends Base {
    init() {
      this.btn = this.el('to-cart-button');
      this.addEventListener('click', (e) => {
        if (!this.has('form-child')) e.preventDefault();
        if (this.btn && this.btn.disabled) return;
        this.loading(true);
        if (!this.has('form-child')) bus.pub(EV.CART_ADD, { items: [{ id: +this.getAttribute('variant-id'), quantity: 1 }] }, this.sec);
      });
      this.sub(EV.CART_UPDATE, () => setTimeout(() => this.loading(false), 1500), { global: true });
      this.sub(EV.CART_ERROR, () => setTimeout(() => this.loading(false), 1500), { global: true });
    }
    loading(s) { this.btn && this.btn.classList.toggle('!loading', s); }
  });
  const live = new Set();
  def('cart-provider', class extends Base {
    init() {
      this.sub(EV.CART_REGISTER, (s) => live.add(s), { global: true });
      this.sub(EV.CART_ADD, (d) => this._req('cartAdd', '/cart/add.js', { items: d.items }), { global: true });
      this.sub(EV.CART_CHANGE, (d) => this._req('cartChange', '/cart/change.js', { line: d.line, quantity: d.quantity }), { global: true });
      this.sub(EV.CART_REPLACE, async (d) => {
        await this._post('/cart/change.js', { line: d.line, quantity: 0 });
        this._req('cartAdd', '/cart/add.js', { items: [{ id: d.newItem, quantity: +d.quantity }] });
      }, { global: true });
      this.sub(EV.FORM_SUBMIT, (d) => this._form(d.formData), { global: true });
      document.addEventListener('cart:refresh', async () => {
        const s = await (await fetch(`${(window.tcb && window.tcb.root) || '/'}?sections=${[...live].join(',')}`)).json();
        bus.pub(EV.CART_UPDATE, { sections: s }, null);
      });
    }
    _post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }
    async _req(route, url, body) {
      try {
        const r = await this._post(url, { ...body, sections: [...live].join(',') }); const d = await r.json();
        if (!r.ok) { bus.pub(EV.TOAST, { type: 'error', msg: d.description, title: d.message }, null); throw new Error(d.description); }
        bus.pub(EV.CART_UPDATE, { sections: d.sections, req: route }, null);
      } catch (e) { console.error(e); bus.pub(EV.CART_ERROR, e, null); }
    }
    async _form(fd) {
      fd.append('sections', [...live].join(','));
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd });
        const d = await r.json();
        if (!r.ok) { bus.pub(EV.TOAST, { type: 'error', msg: d.description, title: d.message }, null); throw new Error(d.description); }
        bus.pub(EV.CART_UPDATE, { sections: d.sections, req: 'cartAdd' }, null);
      } catch (e) { console.error(e); bus.pub(EV.CART_ERROR, e, null); }
    }
  });
  def('cart-qty', class extends Base {
    init() {
      const evt = this.has('input') ? 'change' : 'click';
      this.addEventListener(evt, (e) => {
        if (this.has('prevent-default')) e.preventDefault();
        let q = this.num('value');
        if (evt === 'change') { const t = e.target, mx = t.hasAttribute('max') && +t.getAttribute('max'); q = mx && t.value > mx ? (t.value = mx) : t.value; }
        bus.pub(EV.CART_CHANGE, { key: this.getAttribute('key'), line: this.num('line'), quantity: +q }, this.sec);
      });
    }
  });
  def('cart-live-region', class extends Base {
    init() {
      this.target = this.getAttribute('target-section') || this.sec;
      this.sel = this.getAttribute('target-element') || `#${CSS.escape(this.id)}`;
      live.add(this.target);
      this.sub(EV.CART_UPDATE, ({ sections }) => {
        const s = sections && sections[this.target]; if (!s) return;
        const n = parse(s).querySelector(this.sel); if (!n) return;
        replaceContent(this, n); applyLiquidStates(this);
      }, { global: true });
    }
  });
  def('cart-drawer', class extends Base {
    init() {
      this.sub(EV.CART_UPDATE, ({ req }) => { if (req === 'cartAdd') { const m = this.querySelector('modal-container'); m && m.open(); } }, { global: true });
      const busy = ({ key }) => { this.busy = this.querySelector(`[data-item-key="${CSS.escape(String(key))}"]`); state(this.busy, 'loading', true); };
      this.sub(EV.CART_CHANGE, busy, { global: true }); this.sub(EV.CART_REPLACE, busy, { global: true });
      this.sub(EV.CART_ERROR, () => state(this.busy, 'loading', false), { global: true });
    }
  });
  def('cart-variant-selector-modal', class extends Base {
    init() {
      this.addEventListener('change', (e) => {
        e.stopPropagation(); e.preventDefault();
        bus.pub(EV.CART_REPLACE, { key: this.getAttribute('old-key'), newItem: e.target.value, quantity: e.target.dataset.quantity, line: this.num('old-line-index') }, this.sec);
        const m = this.querySelector('modal-container'); m && m.close();
      });
      const m = this.querySelector('modal-container'); m && m.addEventListener('modal-close', (e) => e.stopPropagation());
    }
  });
  def('free-shipping-progress-bar', class extends Base {
    init() {
      const total = parseInt(this.getAttribute('cart-amount'), 10) || 0, thr = parseInt(this.getAttribute('free-shipping-amount'), 10) || 0;
      const free = thr - total <= 0, prog = thr ? Math.round(total * 100 / thr) : 0;
      show(this.el('msg-eligible'), free); show(this.el('msg-shortage'), !free);
      if (this.has('hide-on-complete')) show(this.el('progress'), !free);
      const p = this.el('progress'); p && p.style.setProperty('--progress', Math.min(prog, 100));
      const amt = !free && this.el('msg-shortage') && this.el('msg-shortage').querySelector('[data-i18n-amount]');
      if (amt) amt.innerHTML = money(thr - total);
    }
  });
  def('sticky-add-to-cart', class extends Base {
    init() {
      this.sub(EV.VARIANT_CHANGE, () => this.classList.add('!loading'));
      this.sub(EV.VARIANT_UPDATE, () => this.classList.remove('!loading'));
      this.sub(EV.VARIANT_UNAVAILABLE, (s) => show(this, !s));
      if (this.has('sticky-bottom')) document.body.style.setProperty('--bottom-offset', '0px');
      const trg = this.el('observer-trigger'), wr = this.el('wrapper');
      if (!trg) return;
      new IntersectionObserver(([en]) => {
        const on = !en.isIntersecting && en.boundingClientRect.top <= 0;
        this.classList.toggle('!active', on);
        if (MQ_DESKTOP.matches && !this.has('sticky-bottom')) document.body.style.setProperty('--sticky-add-to-cart-top-offset', on && wr ? `${wr.offsetHeight}px` : '0px');
      }).observe(trg);
    }
  });

  /* ---------- vídeo (Plyr, MIT, carregado sob demanda) ---------- */
  let plyrP = null;
  const loadPlyr = () => plyrP || (plyrP = new Promise((res) => {
    if (window.Plyr) return res();
    const s = document.createElement('script'); s.src = 'https://cdn.jsdelivr.net/npm/plyr@3.7.8/dist/plyr.polyfilled.min.js'; s.onload = () => res(); document.head.append(s);
  }));
  def('video-player', class extends Base {
    init() {
      if (this.has('inited')) replaceContent(this.el('video-wrapper'), this.el('video-template'));
      loadPlyr().then(() => {
        const p = this.el('player') || this.querySelector('video'); if (!p) return;
        this.player = new window.Plyr(p, { ratio: '16:9' }); this.player.loop = this.has('loop'); this.setAttribute('inited', '');
      });
    }
    play() { this.player && this.player.play(); }
    pause() { this.player && this.player.pause(); }
  });
  def('video-popup', class extends Base {
    init() {
      this.addEventListener('modal-open', () => { if (this.has('autoplay')) { const p = this.querySelector('video-player'); p && p.play(); } });
      this.addEventListener('modal-close', () => { const p = this.querySelector('video-player'); p && p.pause(); });
    }
  });

  /* ---------- navegação ---------- */
  def('tabs-nav', class extends Base {
    init() {
      const tabs = this.els('tab-nav'); this.act = tabs[0];
      tabs.forEach(t => t.addEventListener('click', () => {
        if (t === this.act) return;
        if (window.innerWidth <= 992) t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        state(this.act, 'active', false); this.act = t; state(t, 'active', true);
      }));
    }
  });
  const toolbarQueue = [];
  def('main-nav-mobile', class extends Base {
    init() {
      this.addEventListener('change', (e) => this.style.setProperty('--main-nav-mobile-level', e.target.value));
      const tb = this.el('toolbar');
      while (toolbarQueue.length && tb) tb.prepend(...toolbarQueue.shift());
      this._tb = tb;
    }
  });
  def('main-nav-mobile-toolbar', class extends Base {
    init() {
      customElements.whenDefined('main-nav-mobile').then(() => {
        const m = document.querySelector('main-nav-mobile'); const nodes = Array.from(this.childNodes);
        if (m && m._tb) m._tb.prepend(...nodes); else toolbarQueue.push(nodes);
        this.remove();
      });
    }
  });
  def('scroll-to-top-button', class extends Base {
    init() {
      this.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
      const t = this.el('trigger');
      if (this.has('observe') && t) new IntersectionObserver((en) => state(this.el('button'), 'active', !en[0].isIntersecting)).observe(t);
    }
  });

  /* ---------- busca preditiva (seção r_predictive-search, como o Multi) ---------- */
  const psCache = new Map();
  def('predictive-search', class extends Base {
    init() {
      this.input = this.el('search-input'); this.results = this.el('results'); this.initial = this.el('initial');
      this._outer = (e) => { if (!this.contains(e.target) && this._active && document.activeElement !== this.input) this.active(false); };
      let t;
      this.input && this.input.addEventListener('focus', () => this.active(this.minChars() || !!this.initial));
      this.input && this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this._query(), 300); });
      const btn = this.el('button'); btn && btn.addEventListener('click', (e) => { if (!this.input.value) { e.preventDefault(); this.input.focus(); } });
      const sel = this.el('product-type-select'); sel && sel.addEventListener('change', () => { this._query(); this.input.focus(); });
    }
    minChars() { return this.input.value.trim().length >= 3; }
    q() { const v = this.input.value.trim(), s = this.el('product-type-select'); return s && s.value !== '' ? `product_type:${s.value} AND ${v}` : v; }
    async _query() {
      if (!this.minChars()) { if (this.initial) { show(this.initial, true); this.active(true); } else this.active(false); show(this.results, false); return; }
      const q = this.q();
      if (!psCache.has(q)) {
        state(this, 'loading', true);
        try {
          const p = new URLSearchParams({ q, 'resources[limit]': this.num('results-limit') || 5, section_id: 'r_predictive-search' });
          const d = parse(await (await fetch(`/search/suggest?${p}`)).text()).querySelector('[data-template]');
          psCache.set(q, { has: !d.hasAttribute('data-empty-results'), el: d });
        } catch (e) { console.error(e); }
        state(this, 'loading', false);
      }
      const c = psCache.get(q); if (!c) return;
      replaceContent(this.results, c.el); if (this.initial) show(this.initial, !c.has); show(this.results, true); this.active(true);
    }
    active(on) {
      if (on === this._active) return; this._active = on; state(this, 'active', on);
      if (on) setTimeout(() => document.addEventListener('click', this._outer), 20); else document.removeEventListener('click', this._outer);
    }
  });

  /* ---------- coleções: ordenação e paginação pela seção renderizada (mesmo fluxo do Multi) ---------- */
  const colCache = new Map();
  const updateFrom = (el, doc) => { const f = el.id && doc.getElementById(el.id); if (f) { replaceContent(el, f, true); applyLiquidStates(el); } };
  def('collection-provider', class extends Base {
    init() {
      this.sortBy = this.getAttribute('sort-by');
      this.sub('collection:change', (d) => this._change(d));
      this.sub('collection:sort-change', (d) => this._sort(d));
      this.params = new URLSearchParams(location.search);
      colCache.set(this.params.toString(), document.cloneNode(true));
    }
    async _change({ src, url }) {
      this.params = new URL(location.origin + url).searchParams;
      if (this.sortBy) this.params.set('sort_by', this.sortBy);   // como o Multi: a página leva o sort_by atual
      if (src !== 'dynamic-pagination') this._top();
      await this._doc(src !== 'dynamic-pagination'); this._hist(); this.pub('collection:updated', { src, doc: this.doc });
    }
    async _sort({ value }) {
      this.sortBy = value; this.params.set('sort_by', value); this.params.delete('page');
      this._top(); await this._doc(true); this._hist(); this.pub('collection:updated', { src: 'sort', doc: this.doc });
    }
    async _doc(loading) {
      const k = this.params.toString();
      if (colCache.has(k)) { this.doc = colCache.get(k); return; }
      const ld = this.el('loader'); if (loading) state(ld, 'loading', true);
      const p = new URLSearchParams(this.params); p.set('section_id', this.sec);
      try { this.doc = parse(await (await fetch(`${this.getAttribute('collection-url')}?${p}`)).text()); colCache.set(k, this.doc); } catch (e) { console.error(e); }
      state(ld, 'loading', false);
    }
    _hist() { const p = new URLSearchParams(this.params); p.delete('section_id'); history.pushState({}, '', `${location.pathname}?${p}`); }
    _top() {
      const hh = parseFloat(document.documentElement.style.getPropertyValue('--header-height')) || 0;
      window.scrollTo({ top: this.getBoundingClientRect().top + window.scrollY - hh, behavior: 'smooth' });
    }
  });
  def('collection-products', class extends Base {
    init() {
      this.sub('collection:updated', ({ doc, src }) => {
        if (src !== 'dynamic-pagination') { updateFrom(this, doc); return; }
        const f = doc.getElementById(this.id); const add = f && f.querySelector('[data-element="products-container"]');
        if (add) this.el('products-container').append(...add.childNodes);
      });
    }
  });
  def('collection-sort', class extends Base {
    init() { this.addEventListener('change', (e) => { if (e.target.matches('select')) setTimeout(() => this.pub('collection:sort-change', { value: e.target.value }), 20); }); }
  });
  def('collection-sync-sort', class extends Base { init() { this.sub('collection:updated', ({ src, doc }) => { if (src === 'sort') updateFrom(this, doc); }); } });
  def('collection-pagination', class extends Base {
    init() {
      this.sub('collection:updated', ({ doc }) => updateFrom(this, doc));
      this.addEventListener('change', (e) => this.pub('collection:change', { url: e.target.value, src: 'pagination' }));
    }
  });

  /* ---------- avisos (toast) e confirmação de formulários ---------- */
  def('toast-notification', class extends Base {
    init() {
      this.pop = this.el('popover'); this.usePop = !!(this.pop && this.pop.showPopover);
      if (!this.usePop) this.classList.add('@toasts');
      this.sub(EV.TOAST, (d) => this._notify(d), { global: true });
      const c = this.el('close'); c && c.addEventListener('click', () => this._close());
    }
    async _notify({ type, msg, title, autoclose }) {
      if (this.showing) await this._close();
      if (!msg && !title) return;
      this.el('title') && (this.el('title').innerText = title || '');
      this.el('msg') && (this.el('msg').innerText = msg && msg !== title && typeof msg === 'string' ? msg : '');
      this.dataset.type = type || '';
      const auto = autoclose || autoclose === undefined;
      setTimeout(() => {
        const top = stack[stack.length - 1];
        if (top && !this.isClone) {
          const cl = top.appendChild(this.cloneNode(true)); cl.isClone = true; cl._done = false;
          top.closest('modal-container') && top.closest('modal-container').addEventListener('modal-close', () => cl.remove(), { once: true });
          return;
        }
        clearTimeout(this.t); if (auto) this.t = setTimeout(() => this._close(), 5000);
        if (this.usePop) this.pop.showPopover(); else state(this, 'active', true);
        this.showing = true;
      }, 20);
    }
    async _close() {
      if (this.usePop) { this.toggleAttribute('closing', true); await animationsDone(this.pop); this.toggleAttribute('closing', false); try { this.pop.hidePopover(); } catch (e) {} }
      else { state(this, 'active', false); await new Promise(r => setTimeout(r, 300)); }
      this.showing = false; if (this.isClone) this.remove();
    }
  });
  def('posted-popup', class extends Base {
    init() {
      const u = new URL(location.href), al = { contact_posted: this.getAttribute('contact-msg'), customer_posted: this.getAttribute('newsletter-msg') };
      Object.keys(al).forEach(k => {
        if (!u.searchParams.get(k)) return;
        customElements.whenDefined('toast-notification').then(() => bus.pub(EV.TOAST, { title: al[k], type: 'success' }, null));
        u.searchParams.delete(k); history.replaceState(history.state, '', u.href);
      });
    }
  });

  /* ---------- avaliações Okendo (réplica estática: marcação servida + JSON de todas as avaliações) ---------- */
  const OKE_STAR = 20.6651, PAGE = 5;
  const okeRel = (iso) => {
    const d = (Date.now() - new Date(iso).getTime()) / 1000, h = d / 3600, day = h / 24;
    if (h < 1) { const m = Math.floor(d / 60); return m < 1 ? 'Just now' : m === 1 ? '1 minute ago' : `${m} minutes ago`; }   // referência: "54 minutes ago"
    if (h < 24) { const n = Math.floor(h); return n === 1 ? '1 hour ago' : `${n} hours ago`; }
    if (day < 2) return 'Yesterday';
    if (day < 7) return `${Math.floor(day)} days ago`;
    if (day < 30) { const n = Math.floor(day / 7); return n === 1 ? '1 week ago' : `${n} weeks ago`; }
    if (day < 365) { const n = Math.floor(day / 30.44); return n === 1 ? '1 month ago' : `${n} months ago`; }
    const n = Math.floor(day / 365.25); return n === 1 ? '1 year ago' : `${n} years ago`;
  };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  function okendo(box) {
    // classe de tamanho do widget (o app mede a largura: pequeno < ~680 px, grande >= ~960 px; medido na referência)
    const sz = box.querySelector('.js-oke-widgetSize');
    if (sz && window.ResizeObserver) new ResizeObserver(([e]) => { const w = e.contentRect.width;
      sz.classList.toggle('oke-is-small', w < 680); sz.classList.toggle('oke-is-medium', w >= 680 && w < 960); sz.classList.toggle('oke-is-large', w >= 960); }).observe(sz);
    const ul = box.querySelector('.oke-w-reviews-list'); if (!ul) return;
    ul.setAttribute('widgetwidth', String(Math.round(ul.getBoundingClientRect().width)));
    const items = Array.from(ul.querySelectorAll('li.oke-w-reviews-list-item'));
    if (!items.length) return;
    const base = (items.find(li => li.querySelector('.oke-external-provider')) || items[0]).cloneNode(true);
    const verifiedHTML = '<div class="oke-w-reviewer-verified"> Verified Buyer <span class="oke-w-reviewer-verified-icon"></span></div>';
    const tagHTML = (items.find(li => li.querySelector('.oke-external-provider')) || {}).querySelector ? items.find(li => li.querySelector('.oke-external-provider')).querySelector('.oke-external-provider').outerHTML : '';
    let data = null, order = (box.querySelector('select.oke-sortSelect-sort') || {}).value || 'date desc', shown = items.length;
    const ratings = new Set();
    let ords = {};
    const load = async () => { if (!data) { try { const j = await (await fetch(box.dataset.tcbOke)).json(); data = j.reviews; ords = j.orders || {}; } catch (e) { data = []; } } return data; };
    const cmp = { 'date desc': (a, b) => b.date.localeCompare(a.date), 'date asc': (a, b) => a.date.localeCompare(b.date),
      'helpful desc': (a, b) => (b.up - a.up) || b.date.localeCompare(a.date), 'rating desc': (a, b) => (b.rating - a.rating) || b.date.localeCompare(a.date),
      'rating asc': (a, b) => (a.rating - b.rating) || b.date.localeCompare(a.date), 'unhelpful desc': (a, b) => (b.down - a.down) || b.date.localeCompare(a.date) };
    const sorted = () => {
      // sem filtro: a mesma ordem que a API do Okendo devolve (gravada na captura); com filtro de estrelas: ordem da opção, empate pela data
      if (!ratings.size) { const idx = ords[order] || data.map((_, k) => k); return idx.map(k => data[k]).filter(Boolean); }
      return data.filter(r => ratings.has(r.rating)).sort(cmp[order]);
    };
    const item = (r) => {
      const li = base.cloneNode(true);
      li.querySelector('.oke-w-reviewer-name').textContent = ` ${r.name} `;
      const idn = li.querySelector('.oke-w-reviewer-identity'); const vf = li.querySelector('.oke-w-reviewer-verified');
      if (vf) vf.remove(); if (r.verified && idn) idn.insertAdjacentHTML('afterend', verifiedHTML);
      li.querySelector('.oke-w-reviewMinimal-date').textContent = ` ${okeRel(r.date)} `;
      li.querySelector('.oke-stars-foreground').style.width = `${Math.min(100, r.rating * OKE_STAR)}%`;
      li.querySelector('.oke-stars .oke-a11yText').textContent = `Rated ${r.rating} out of 5 stars`;
      li.querySelector('.oke-reviewContent-title').textContent = r.title;
      li.querySelector('.oke-reviewContent-body').innerHTML = '<p>' + esc(r.body).replace(/\n/g, '<br>') + '</p>';
      const c = li.querySelector('.oke-reviewContent'); c.classList.remove('oke-is-truncated'); li.querySelector('.oke-reviewContent-body').removeAttribute('style');
      const fb = li.querySelector('.oke-footerBadges'); const tg = fb && fb.querySelector('.oke-external-provider'); if (tg) tg.remove();
      if (fb && r.provider === 'shopify-shop' && tagHTML) fb.insertAdjacentHTML('beforeend', tagHTML);
      const [yes, no] = li.querySelectorAll('.oke-helpful-vote-button');
      if (yes) { yes.setAttribute('aria-label', `Yes, this review from ${r.name} was helpful. ${r.up} people voted yes`); yes.setAttribute('aria-pressed', 'false'); const s = yes.querySelector('.oke-helpful-vote-counter'); s.textContent = ` ${r.up} `; s.id = `oke-helpful-vote-counter-positive-${r.id}`; }
      if (no) { no.setAttribute('aria-label', `No, this review from ${r.name} was not helpful. ${r.down} people voted no`); no.setAttribute('aria-pressed', 'false'); const s = no.querySelector('.oke-helpful-vote-counter'); s.textContent = ` ${r.down} `; s.id = `oke-helpful-vote-counter-negative-${r.id}`; }
      return li;
    };
    const more = () => box.querySelector('.oke-w-reviews-footer button, button.oke-w-reviews-load-more, .oke-w-reviews-loadMore');
    const findMore = () => Array.from(box.querySelectorAll('button')).find(b => /Show More/i.test(b.textContent));
    const truncate = (scope) => scope.querySelectorAll('.oke-reviewContent').forEach(c => {
      const body = c.querySelector('.oke-reviewContent-body'); if (!body || c.dataset.tcbOpen) return;
      body.removeAttribute('style'); c.classList.remove('oke-is-truncated');
      const cs = getComputedStyle(body), lh = parseFloat(cs.lineHeight) || 24, max = lh * 5 + (parseFloat(cs.fontSize) || 15);   // 5 linhas + 1 fonte (medido na referência: 24 px x 5 + 15 = 135)
      if (body.scrollHeight > max + 2) { c.classList.add('oke-is-truncated'); body.style.height = `${max}px`; }
    });
    const render = (list, from, to, reset) => {
      if (reset) ul.replaceChildren();
      list.slice(from, to).forEach(r => ul.append(item(r)));
      shown = to; const mb = findMore(); const total = list.length;
      if (mb) (mb.closest('.oke-w-reviews-footer') || mb).toggleAttribute('hidden', shown >= total);
      const cnt = box.querySelector('.oke-w-reviews-count'); if (cnt && reset) cnt.textContent = ` ${total.toLocaleString()} review${total === 1 ? '' : 's'} `;
      truncate(ul);
    };
    truncate(box);
    // datas relativas das avaliações servidas, recalculadas a partir dos dados (o texto servido envelhece)
    // a 1ª página servida envelhece (datas relativas, avaliações novas): refeita a partir dos dados capturados, na mesma ordem
    const fixDates = async () => { await load(); if (data.length) render(sorted(), 0, Math.max(PAGE, 0), true); };
    ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(fixDates);
    box.addEventListener('click', async (e) => {
      const rm = e.target.closest('.oke-readMore');
      if (rm) { const c = rm.closest('.oke-reviewContent'); c.dataset.tcbOpen = '1'; c.classList.remove('oke-is-truncated'); c.querySelector('.oke-reviewContent-body').removeAttribute('style'); return; }
      const hv = e.target.closest('.oke-helpful-vote-button');
      if (hv) {
        const on = hv.getAttribute('aria-pressed') !== 'true', s = hv.querySelector('.oke-helpful-vote-counter');
        s.textContent = ` ${Math.max(0, parseInt(s.textContent, 10) + (on ? 1 : -1))} `; hv.setAttribute('aria-pressed', String(on)); return;
      }
      if (e.target.closest('.oke-w-reviews-filterToggle')) {
        const t = e.target.closest('.oke-w-reviews-filterToggle'), reg = box.querySelector('#filter-options');
        const open = t.getAttribute('aria-expanded') !== 'true'; t.setAttribute('aria-expanded', String(open));
        const tp = box.querySelector('template.tcb-oke-filters');
        if (reg) { if (open && tp) { reg.innerHTML = tp.innerHTML;
          reg.querySelectorAll('[style*="height"]').forEach(el => { el.style.height = ''; });   // o modelo foi capturado no início da animação (height: 0px)
          reg.querySelectorAll('.oke-w-filterOption-checkbox').forEach(c => { c.checked = ratings.has(parseInt(c.name.replace(/\D/g, ''), 10)); }); } else if (!open) reg.innerHTML = '<!---->'; }
        return;
      }
      const mb = e.target.closest('button'); if (mb && /Show More/i.test(mb.textContent)) {
        e.preventDefault(); await load(); const list = sorted();
        if (shown === items.length && !ul.dataset.tcbReset && order === ((box.querySelector('select.oke-sortSelect-sort') || {}).value)) {
          // primeira página veio do servidor; as próximas saem do JSON na mesma ordem
        }
        render(list, shown, shown + PAGE, false);
      }
    });
    box.addEventListener('change', async (e) => {
      if (e.target.matches('select.oke-sortSelect-sort')) { order = e.target.value; await load(); ul.dataset.tcbReset = '1'; render(sorted(), 0, PAGE, true); }
      if (e.target.matches('.oke-w-filterOption-checkbox')) {
        const n = parseInt((e.target.name || '').replace(/\D/g, ''), 10); e.target.checked ? ratings.add(n) : ratings.delete(n);
        await load(); ul.dataset.tcbReset = '1'; render(sorted(), 0, PAGE, true);
      }
    });
    box.querySelectorAll('.oke-w-writeReview').forEach(a => a.addEventListener('click', (e) => e.preventDefault()));
  }

  /* ---------- estados vindos do Liquid (checked/selected sem depender da referência) ---------- */
  function applyLiquidStates(root) {
    root.querySelectorAll('[data-tcb-checked]').forEach(i => { i.checked = i.getAttribute('data-tcb-checked') === '1'; if (i.checked) i.setAttribute('checked', ''); else i.removeAttribute('checked'); });
    root.querySelectorAll('option[data-tcb-selected]').forEach(o => { o.selected = o.getAttribute('data-tcb-selected') === '1'; });
    root.querySelectorAll('product-variant-selector').forEach(markAvailability);
  }
  window.TCB = { bus, EV, money, applyLiquidStates };

  /* ---------- globais do layout ---------- */
  const boot = () => {
    applyLiquidStates(document);
    document.querySelectorAll('[data-tcb-oke]').forEach(b => { try { okendo(b); } catch (e) { console.error('okendo', e); } });
    const header = document.querySelector('[id^="mainHeader"]');
    if (header && window.ResizeObserver) new ResizeObserver(([e]) => document.documentElement.style.setProperty('--header-height', `${Math.floor(e.contentBoxSize[0].blockSize)}px`)).observe(header);
    if (window.innerWidth <= 992) {
      const vh = () => document.documentElement.style.setProperty('--mobile-viewport-height', window.innerHeight + 'px');
      window.addEventListener('resize', vh); vh();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // réplica do formulário Gorgias (iframe local): altura acompanha o conteúdo, como o carregador do app
  window.addEventListener('message', (e) => {
    if (!e.data || typeof e.data.tcbGorgias !== 'number') return;
    document.querySelectorAll('iframe[data-tcb-gorgias]').forEach(f => { if (f.contentWindow === e.source) f.setAttribute('height', String(e.data.tcbGorgias)); });
  });
  window.addEventListener('load', () => document.documentElement.style.setProperty('--scrollbar-offset', `${window.innerWidth - document.body.offsetWidth}px`));
})();
